import { render, staticRenderFns } from "./NewsTeaser.vue?vue&type=template&id=5da839a3"
import script from "./NewsTeaser.vue?vue&type=script&lang=js"
export * from "./NewsTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports